import { render, staticRenderFns } from "./PaymentRecords.vue?vue&type=template&id=5255c676&scoped=true"
import script from "./PaymentRecords.vue?vue&type=script&lang=js"
export * from "./PaymentRecords.vue?vue&type=script&lang=js"
import style0 from "./PaymentRecords.vue?vue&type=style&index=0&id=5255c676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255c676",
  null
  
)

export default component.exports